import React from "react";

const SwitchInput = (props) => {
  const { checked, onChange, rightLabel, leftLabel, disabled, containerClasses } = props;
  return (
    <div className={`switch-container ${containerClasses ?? ""}`}>
      <label className="left-label">{leftLabel}</label>
      <label className="switch">
        <input type="checkbox" checked={checked} onChange={onChange} disabled={disabled} />
        <span className="slider round"></span>
      </label>
      <label className="right-label">{rightLabel}</label>
    </div>
  );
};

export default SwitchInput;
